import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Import the router
import pinia from "./store";  // Import Pinia
import "./assets/fonts.css";
import "./tailwind.css";

const app = createApp(App); // Assign app instance to a variable
app.use(pinia);             // Use Pinia
app.use(router);            // Use the router
app.mount("#app");
